// extracted by mini-css-extract-plugin
module.exports = {"fcContentWrapper":"_fcContentWrapper--wnYp6"};